import { createSlice } from "@reduxjs/toolkit";
import { fetchFromStorage, removeFromStorage, saveToStorage } from "../../storage";

interface SearchedDataState {
  searchedData: any;
  searchFormData: any;
  venueList: any;
  selectedOrg: any,
  eventTypeList: any,
  timeSlotList: any,
  initialDateForCalendar: any;
}
const searchedDataSlice = createSlice({
  name: "searchedDataSlice",
  initialState: {
    searchedData: [],
    searchFormData: JSON.parse(
      fetchFromStorage("searchFormData", true) as string) || {},
    venueList: {},
    selectedOrg: fetchFromStorage("selectedOrg", true),
    eventTypeList: [],
    timeSlotList: [],
    initialDateForCalendar: '2024-09-01'
  },
  reducers: {
    setSearchedData(state, action) {
      state.searchedData = action.payload;
      saveToStorage('searchedData', JSON.stringify(action.payload), true);
    },
    setSearchFormData(state, action) {
      state.searchFormData = action.payload;
      saveToStorage('searchFormData', JSON.stringify(action.payload), true);
    },
    setVenueList(state, action) {
      state.venueList = action.payload;
      saveToStorage('venueList', JSON.stringify(action.payload), true);
    },
    setSelectedOrg(state, action) {
      state.selectedOrg = action.payload;
      saveToStorage('selectedOrg', JSON.stringify(action.payload), true);
    },
    setEventTypeList(state, action) {
      state.eventTypeList = action.payload;
      saveToStorage('eventTypeList', JSON.stringify(action.payload), true);
    },
    setTimeSlotList(state, action) {
      state.timeSlotList = action.payload;
      saveToStorage('timeSlotList', JSON.stringify(action.payload), true);
    },
    setSearchDataSliceInitState(state, action) {
      state.searchedData = [];
      removeFromStorage('searchedData', true);
      state.searchFormData = {};
      removeFromStorage('searchFormData', true);
      state.venueList = {};
      removeFromStorage('venueList', true);
      state.selectedOrg = null;
      removeFromStorage('selectedOrg', true);
    },
    setSearchDataSliceInitStateForOid(state, action) {
      state.searchedData = [];
      removeFromStorage('searchedData', true);
      state.searchFormData = action.payload;
      saveToStorage('searchFormData', JSON.stringify(action.payload), true);
      state.venueList = {};
      removeFromStorage('venueList', true);
    },
    setInitialDate(state, action) {
      state.initialDateForCalendar = action.payload;
    },
  },

});

export default searchedDataSlice.reducer;

export const { setSearchedData, setSearchFormData, setVenueList, setSelectedOrg, setSearchDataSliceInitState, setEventTypeList, setTimeSlotList, setSearchDataSliceInitStateForOid, setInitialDate } = searchedDataSlice.actions;

export const searchedData = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.searchedData;
export const searchFormData = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.searchFormData;
export const venueList = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.venueList;
export const selectedOrg = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.selectedOrg;
export const eventTypeList = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.eventTypeList;
export const timeSlotList = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.timeSlotList;

export const initialDateForCalendar = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.initialDateForCalendar;
